import React, {Component} from 'react';
import ReactMarkdown from 'react-markdown';
import readme from './THEME_MANAGER.md';

import components from '../../styles/_vars.scss';

// todo: should get this information out of a remote README.md
export default class ThemeManager extends Component {
  render() {
    return (
      <div className={[components.page]}>
        <ReactMarkdown source={readme}/>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./components/ThemeManager/index.js